export default __webpack_public_path__ + "static/media/Spectral-ExtraBold.b51669d7.ttf";